
import Vue from "vue";
Vue.component('test-app', require("./components/Test.vue").default)
Vue.component('svg-comp', require("./components/svg-news.vue").default)
Vue.component('svg-events', require("./components/svg-events.vue").default)
Vue.component('svg-opp', require("./components/svg-opp.vue").default)

Vue.component('contact-location', require("./components/svg-location.vue").default)
Vue.component('contact-clock', require("./components/svg-clock.vue").default)
Vue.component('contact-mail', require("./components/svg-mail.vue").default)
Vue.component('contact-phone', require("./components/svg-phone.vue").default)

Vue.component('news-latest', require("./components/news-latest.vue").default)
Vue.component('events-form', require("./components/events-form.vue").default)
Vue.component('opp-form', require("./components/opp-form.vue").default)

Vue.mixin({ methods: { route: window.route } })

import Toast from "vue-toastification";
import "vue-toastification/dist/index.css";

Vue.use(Toast, {
    transition: "Vue-Toastification__bounce",
    maxToasts: 20,
    newestOnTop: true
});

//import 'vue-toast-notification/dist/theme-sugar.css';

window.Bus = new Vue();

import AOS from 'aos'
import 'aos/dist/aos.css'
Vue.use(require('vue-moment'));

const app = new Vue({
    el: "#app",
    mounted() {
        AOS.init({
            disable: 'mobile',
            once: true,
        })
    },
});
